import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export const SUPPORTED_CURRENCIES = [
  { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'GBP', name: 'British Pound', symbol: '£' },
  { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$' },
  { code: 'KRW', name: 'South Korean Won', symbol: '₩' },
  { code: 'AED', name: 'UAE Dirham', symbol: 'AED' },
  { code: 'USD', name: 'US Dollar', symbol: '$' },
  { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$' },
   { code: 'MultiDevices', name: 'Multi Device Currency', symbol: 'EUR' },
] as const;

export type CurrencyCode = typeof SUPPORTED_CURRENCIES[number]['code'];

export const getCurrencySymbol = (code: CurrencyCode): string => {
  const found = SUPPORTED_CURRENCIES.find(c => c.code === code);
  return found?.symbol || code;
};


export const CURRENCY_TO_ODOO_FIELD: Record<CurrencyCode, string> = {
  CHF: 'PriceCHFEnt',
  EUR: 'PriceEUREnt',
  GBP: 'PriceGBPEnt',
  HKD: 'PriceHKDEnt',
  KRW: 'PriceKRWEnt',
  AED: 'PriceAEDEnt',
  USD: 'PriceUSDEnt',
  SGD: 'PriceSGDEnt',
  MultiDevices: 'PriceEUREnt',
};

interface CurrencyState {
  selectedCurrency: CurrencyCode;
  setCurrency: (currency: CurrencyCode) => void;
  initializeFromUserDefault: (defaultCurrency: string | null | undefined) => void;
}

// export const useCurrencyStore = create<CurrencyState>()(
//   persist(
//     (set) => ({
//       selectedCurrency: 'EUR', 
      
//       setCurrency: (currency: CurrencyCode) => {
//         set({ selectedCurrency: currency });
//       },
      
//       initializeFromUserDefault: (defaultCurrency: string | null | undefined) => {
//         if (!defaultCurrency) return;
        
//         const normalized = defaultCurrency.trim().toUpperCase();
//         const isValid = SUPPORTED_CURRENCIES.some(c => c.code === normalized);
        
//         if (isValid) {
//           set({ selectedCurrency: normalized as CurrencyCode });
//         }
//       },
//     }),
//     {
//       name: 'currency-storage',
//       storage: createJSONStorage(() => localStorage),
//     }
//   )
// );

export const useCurrencyStore = create<CurrencyState>()(
  persist(
    (set) => ({
      selectedCurrency: 'EUR',

      setCurrency: (currency: CurrencyCode) => {
        set({ selectedCurrency: currency });
      },

      initializeFromUserDefault: (defaultCurrency: string | null | undefined) => {
        if (!defaultCurrency) return;

        let normalized = defaultCurrency.trim().toUpperCase();

        // 🚨 Client Rule: MultiDevices can NEVER be default → replace with EUR
        if (normalized === "MULTIDEVICES") {
          normalized = "EUR";
        }

        const isValid = SUPPORTED_CURRENCIES.some(c => c.code === normalized);

        if (isValid) {
          set({ selectedCurrency: normalized as CurrencyCode });
        }
      },
    }),
    {
      name: 'currency-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);